import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '../action/logout-action';

interface PortfolioImage {
  id: string;
  imageUrl: string;
}

interface PortfolioFormData {
  id?: string;
  title: string;
  description: string;
  url: string;
  portfolioImages: PortfolioImage[];
}

interface PortfolioState {
  portfolioList: PortfolioFormData[];
}

const initialState: PortfolioState = {
  portfolioList: [
    {
      id: "00000000-0000-0000-0000-000000000000",
      title: "",
      description: "",
      url: "",
      portfolioImages: [],
    },
  ],
};

const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState,
  reducers: {
    setPortfolioData: (state, action: PayloadAction<PortfolioFormData[]>) => {
      state.portfolioList = action.payload;
    },
    resetPortfolioData: (state) => {
      state.portfolioList = initialState.portfolioList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setPortfolioData, resetPortfolioData } = portfolioSlice.actions;
export default portfolioSlice.reducer; 